const STATES = {
  // invitation
  draft: "bg-stone-100 text-stone-600",
  sent: "bg-[#DBEAFE] text-[#1E40AF]",
  opened: "bg-[#FEF3C7] text-[#B45309]",
  redeemed: "bg-[#D1FAE5] text-[#065F46]",
  expired: "bg-stone-100 text-stone-500",
  revoked: "bg-[#FEE2E2] text-[#991B1B]",
  // requests
  received: "bg-[#DBEAFE] text-[#1E40AF]",
  needs_information: "bg-[#FEF3C7] text-[#B45309]",
  awaiting_confirmation: "bg-[#FEF3C7] text-[#B45309]",
  confirmed: "bg-[#D1FAE5] text-[#065F46]",
  on_hold: "bg-[#EDE9FE] text-[#5B21B6]",
  redirected: "bg-[#DBEAFE] text-[#1E40AF]",
  alternative_offered: "bg-[#DBEAFE] text-[#1E40AF]",
  cancelled: "bg-stone-100 text-stone-500",
  in_review: "bg-[#FEF3C7] text-[#B45309]",
  approved: "bg-[#D1FAE5] text-[#065F46]",
  declined: "bg-[#FEE2E2] text-[#991B1B]",
  completed: "bg-[#D1FAE5] text-[#065F46]",
  escalated: "bg-[#EDE9FE] text-[#5B21B6]",
  // onboarding / lifecycle
  in_progress: "bg-[#FEF3C7] text-[#B45309]",
  onboarding_in_progress: "bg-[#FEF3C7] text-[#B45309]",
  induction_in_progress: "bg-[#FEF3C7] text-[#B45309]",
  awaiting_review: "bg-[#DBEAFE] text-[#1E40AF]",
  ready_for_review: "bg-[#DBEAFE] text-[#1E40AF]",
  needs_support: "bg-[#EDE9FE] text-[#5B21B6]",
  role_active: "bg-[#D1FAE5] text-[#065F46]",
  active: "bg-[#D1FAE5] text-[#065F46]",
  suspended: "bg-[#FEE2E2] text-[#991B1B]",
  complete: "bg-[#D1FAE5] text-[#065F46]",
};

export function StatePill({ state, className = "" }) {
  const cls = STATES[state] || "bg-stone-100 text-stone-600";
  return (
    <span
      data-testid={`state-pill-${state}`}
      className={`inline-block rounded-full px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${cls} ${className}`}
    >
      {String(state).replace(/_/g, " ")}
    </span>
  );
}
